import appSettings from 'wanderu-config';

import ClientApiService from './clientApiService';
import ServerApiService from './serverApiService';

function initService({ affiliateId, visitorId }) {
    return _getTargetApiService().initService({ affiliateId, visitorId });
}

function injectStore(store) {
    return _getTargetApiService().injectStore(store);
}

async function get(url, init, options) {
    return _getTargetApiService().get(url, init, options);
}

async function del(url, init, options) {
    return _getTargetApiService().delete(url, init, options);
}

async function post(url, init, options) {
    return _getTargetApiService().post(url, init, options);
}

function clearCredentials() {
    return _getTargetApiService().clearCredentials();
}

async function startNewSession(authCredentials, options) {
    return _getTargetApiService().startNewSession(authCredentials, options);
}

function getSessionId() {
    return _getTargetApiService().getSessionId();
}

function onSessionChange(listener) {
    return _getTargetApiService().onSessionChange(listener);
}

function _getTargetApiService() {
    return appSettings.env.isClient
        ? ClientApiService
        : ServerApiService;
}

function restoreSession(opts) {
    return _getTargetApiService().restoreSession(opts);
}

export default {
    clearCredentials,
    delete: del,
    get,
    getSessionId,
    initService,
    injectStore,
    onSessionChange,
    post,
    restoreSession,
    startNewSession,
};
